// Yield without nested timers' minimum delay when the browser supports it.
export function yieldTask(): Promise<void> {
  const { scheduler } = globalThis as typeof globalThis & {
    scheduler?: { yield?: () => Promise<void> };
  };
  return (
    scheduler?.yield?.() ?? new Promise((resolve) => setTimeout(resolve, 0))
  );
}
